// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

// #region Imports

import * as React from 'react';
import BuilderContext from "../../contexts/DataTestIdBuilderContext";
// #endregion
/**
 * Hook permettant de récupérer un data-testid utilisant
 * tous les préfixes "parent" dans l'arbre React
 * @param dataTestId Le data-testid qui sera fusionné aux préfixes
 * @param separator Le séparateur à utiliser entre les chaines
 * @returns
 */
var useDataTestId = function useDataTestId(dataTestId, separator) {
  if (separator === void 0) {
    separator = '-';
  }
  var builder = React.useContext(BuilderContext);
  var completeDataTestId = React.useMemo(function () {
    return builder.add(dataTestId).build(separator);
  }, [builder, dataTestId, separator]);
  return completeDataTestId;
};
export default useDataTestId;